// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"8fb5df02","153":"f715603c","720":"5e123e6c"}[chunkId] + ".chunk.css";
};